import { Dic } from "@src/common/utils";
import i18n from "@src/common/lib/i18n";
import utils from "@src/common/utils";
export const questionOption = function () {
  return {
    add: "新增",
    edit: "修改",
    view: "查看",
    page: true,
    selection: true,
    index: false,
    radio: false,
    indexLabel: "序号",
    refreshBtn: false,
    columnBtn: false,
    stripe: true,
    addBtn: false,
    editBtn: false,
    delBtn: false,
    viewFormSlot: true,
    labelSuffix: "：",
    size: "small",
    maxHeight: "100%",
    labelWidth: "140px",
    menuAlign: "center",
    searchMenuSpan: 6,
    searchBtn: false,
    dialogHeight: 200,
    dialogWidth: "550px",
    emptyText: "暂无数据",
    column: [
      // {
      //   label: "",
      //   prop: "personnelCode",
      //   align: "right",
      //   search: false,
      //   addDisplay: false,
      //   editDisplay: false,
      //   editDisabled: false,
      //   viewDisplay: false,
      //   overHidden: true,
      //   formslot: true,
      //   columnWidth: 50
      // },
      {
        label: "调查项分类",
        prop: "category",
        addDisplay: false,
        editDisplay: false,
        // viewDisplay: false,
        overHidden: true,
        search: true,
        clearable: true,
        searchPlaceholder: "请输入调查项分类名称",
        span: 12
      },
      {
        label: "调查项名称",
        prop: "title",
        search: true,
        addDisplay: false,
        editDisplay: false,
        // viewDisplay: false,
        overHidden: true,
        clearable: true,
        searchPlaceholder: "请输入调查项名称",
        span: 12
      },
      {
        label: "调查项类型",
        prop: "typeName",
        search: true,
        addDisplay: false,
        editDisplay: false,
        // viewDisplay: false,
        overHidden: true,
        // searchPlaceholder: '请输入部门',
        span: 12
      },
     
    ]
  };
};
